import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from "lodash";
import { ToastrService } from 'ngx-toastr';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { base64StringToBlob } from 'blob-util';
import { AppService } from 'src/app/service/app.service';
import { DatatableService } from 'src/app/service/datatable.service';
declare var $: any;

@Component({
  selector: 'app-new-user-approval',
  templateUrl: './new-user-approval.component.html',
  styleUrls: ['./new-user-approval.component.css']
})
export class NewUserApprovalComponent implements OnInit, OnDestroy {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  bsValue: any;
  searchForm: FormGroup;
  entityList: any;
  responseData: any = [];
  statusArray: any = [{ code: 'MAKER_APPROVED', value: 'Maker Approved' },
  { code: 'CHECKER_APPROVED', value: 'Checker Approved' },
  { code: 'SAVED', value: 'Saved' },
  { code: 'SUBMITTED', value: 'Submitted' }];
  showDataTable: boolean = true;
  access: any = {};
  menuCode: string = 'userApproval';

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private titleService: Title,
    private cdref: ChangeDetectorRef,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private formbuilder: FormBuilder,
    private userDetailsService: UserDetailsService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    private appService: AppService,
    private dataTableService: DatatableService
) { }

  get f() {
    return this.searchForm.controls;
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      entity: [''],
      regStatus: [''],
      createdDate: ['']
    })
    this.access = this.userDetailsService.checkUserAccess(this.menuCode);
  
    if (this.access === undefined || this.access.isAccessAllowed != 'Y') {
      this.router.navigate(['/']);
      this.toastr.error("Unauthorize to access this page !");
    }
    this.getDynamicFieldList();
  }

  getDynamicFieldList() {
    this.showDataTable = false;
    this.appService.getDynamicFieldList().pipe(
      catchError((error: any) => {
        this.responseData = [];
        this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.entityList = response.data.entityList;
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
        this.onSubmit();
      } else {
        this.responseData = [];
        this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        this.toastr.error(response.message);
      }
    });

  }

  onSubmit() {
    this.showDataTable = false;
    let requestObject = {
      "entityType": this.f?.entity.value || null,
      "status": this.f?.regStatus.value || null,
      "createdDate": this.f?.createdDate.value || null
    }
    this.appService.fetchRegisterRequests(requestObject).pipe(catchError((error: any) => {
      this.responseData = [];
      this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
      this.showDataTable = true;
      if (error.status != 200) {
        return throwError(error.error);
      }
    })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // this.entityList = response.data.entityList;
        this.responseData = response.data;
        this.appService.addAuthorisedPerson(this.responseData);
        this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        $('.selectpicker').selectpicker('refresh');
      } else {
        this.responseData = [];
        this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        this.toastr.error(response.message);
      }
    });
  }


  open(id: number) {
    this.router.navigate(['/admin/userApproval/adminApproval'], { queryParams: { id: id } });
  }

  makerCheckerAction(action: any, id: any) {
    this.showDataTable = false;
    let requestObject = this.responseData.find(data => data.regID == id);
    requestObject.status = action;
    this.appService.makerCheckerAction(requestObject).pipe(
      catchError((error: any) => {
        this.cdref.detectChanges();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // this.entityList = response.data.entityList;
        this.responseData = response.data;
        // this.appService.addAuthorisedPerson(this.responseData);
        this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        $('.selectpicker').selectpicker('refresh');
      } else {
        this.cdref.detectChanges();
        this.toastr.error(response.message);
      }
    });
  }

  getStatus(code: String) {
    return this.statusArray.find(data => data.code == code)?.value || '';
  }

  clearSearch() {
    this.dataTableService.setDatatable("adminMisReport", 11, 10, [10, 25, 50, 100]);
  }

  reset() {
    this.searchForm.reset();
    this.onSubmit();
  }

  getEntityValue(key) {
    return this.entityList.find(data => data.key == key)?.value;
  }

  ngOnDestroy() {
    this.dtTrigger?.unsubscribe();
  }
}


